import {applyUserFilter, focusUser, openUsersSection} from './adapter';
import {
	openUserCreateModal,
	openUserDeleteModal,
	openUserEditModal,
	openUserSuspendModal,
} from './modal';
import {resolveUsers} from './resolver';
import {readUserStatusCounts} from './statistics';

/**
 * Canvas users.
 *
 * A record collection sharing the Canvas Settings page with Roles, the way
 * SSID Schedules and SSID Templates share the profile dashboard. It declares
 * no fields: the Add and Edit forms are not mapped, so the agent finds a
 * person and opens the form rather than filling it in.
 */
const userPlugin = {
	id: 'user',
	version: 1,
	commandVersion: 1,
	resource: 'user',
	operations: ['options', 'list', 'search', 'open', 'create', 'edit', 'suspend', 'delete', 'stats'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['settings.dashboard'],
	},
	sections: {
		'settings.users': openUsersSection,
	},
	resolvers: {
		user: resolveUsers,
	},
	filters: {
		user: (command) => applyUserFilter(command.params?.query),
	},
	focusHandlers: {
		user: (command) => focusUser(command.params?.entity_id),
	},
	modals: {
		'user.create': openUserCreateModal,
		'user.edit': openUserEditModal,
		'user.suspend': openUserSuspendModal,
		'user.delete': openUserDeleteModal,
	},
	statistics: {
		user_status_counts: readUserStatusCounts,
	},
};

export default userPlugin;
